// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__26xlY","col":"styles_col__3Gvbo","fulfillmentStatus":"styles_fulfillmentStatus__KrarO","emailCol":"styles_emailCol__1JV3-"};